export default __webpack_public_path__ + "static/media/projectsFallbackimage.e21a681f.png";